import React, { Component } from "react";
import { DetilPxContext } from "../../context";
import usePuskesmas from "../hooks/usePuskesmas";
import moment from "moment";
import TableServerSidePagination from "view/component/ServerSideTable/TableServerSidePagination";
import API from "../../apiService";
import { showLoading, toast } from "../component/Alert";


class pelayananList extends Component {
  static contextType = DetilPxContext;
  constructor(props) {
    super(props);
    this.cardNameComponentRefs = [];
    this.printListComponentRef = React.createRef();
    this.socket = this.props.socket;
    this.state = {
      headers: props.headers,
      datas: [],
      filteredDatas: [],
      isLoading: true,
      currentPage: 1,
      form: false,
      detilPx: "",
      index: ""
    };
    this.changeData = this.changeData.bind(this);
    this.getDetailQueue = this.getDetailQueue.bind(this);
  }

  try = (e) => {
    const data = this.state.filteredDatas.data[[e.target.value]];
    this.getDetailQueue(data)

    this.props.history.push(`/PelayananObatList`);
    this.props.history.push(`/PelayananObatList/Resep`);
  };

  async getDetailQueue(data) {
    showLoading('Menyiapkan Data');
    const res = await API.get(`registration/prescribe/detail/${data.id}`)
    this.context.changeDetilPx(res.data.visits[0]);
    this.context.changeSelected(res.data);
    toast({ status: 'success', text: 'selesai menyiapkan data' });
  }

  componentDidUpdate(prevProps) {
    if (this.props.datas !== prevProps.datas) {
      this.setState({
        datas: this.props.datas,
        filteredDatas: this.props.datas,
        isLoading: false,
      });
    }
  }
  changeData(datas) {
    // console.log(datas);
    this.setState({
      filteredDatas: datas,
    });
  }
  getComponentRef = (i) => {
    return this.cardNameComponentRefs[i];
  };

  call = (currentQueueParam, clinicNameParam, clinicId) => {
    this.socket.emit("callQueue", {
      currentQueue: currentQueueParam,
      clinicName: clinicNameParam,
    });
  };

  handlePageChange = (pageNumber) => {
    this.setState({
      currentPage: pageNumber,
    });
  };

  handleFilter = (flag) => {
    const filteredLists = [];
    if (flag !== "") {
      this.state.datas.map((data) => {
        if (data.flg_prolanis === flag) {
          filteredLists.push(data);
        }
        return "";
      });
      this.setState({
        filteredDatas: filteredLists,
        currentPage: 1,
      });
    } else {
      this.setState({
        filteredDatas: this.state.datas,
      });
    }
    return "";
  };

  createBUtton(prescribes, i) {
    let served = false;

    if (prescribes.pharmacist_id !== null) {
      served = true;
    } else {
      served = false;
    }
    if (served) {
      return (
        <div className='row'>
          <button
            onClick={this.try}
            value={i}
            className='btn btn-sm btn-success'>
            &radic;
          </button>
        </div>
      );
    } else {
      return (
        <div className='row'>
          <button
            onClick={this.try}
            value={i}
            className='btn btn-sm btn-primary'>
            +
          </button>
        </div>
      );
    }
  }

  // pilihData(data) {
  //   this.setState({ selectedData: data }, () => this.setState({ show: true }))
  // }
  render() {
    return (
      <div className='table-responsive py-2'>
        <div className='row'>
          <div className='col-sm-12'>
            <TableServerSidePagination
              headers={this.state.headers}
              columnMapper={(data, i) => [
                <div>
                  <button
                    type='button'
                    className='btn btn-warning btn-icon'
                    onClick={() => this.call(`${data.queue}`, "APOTEK", 0)}>
                    <span className='btn-inner--icon'>
                      {/* <i
                      className='fas fa-volume-up'
                      style={{ fontSize: "18px" }}>
                      {" "}
                      {data.queue}
                    </i> */}
                      {data.queue}
                    </span>
                  </button>
                </div>,
                data.created_at,
                data.visits[0].clinics.name,
                data.visits[0].family_folder,
                data.visits[0].patients.nik,
                `${data.visits[0].patients.name} ${data.visits[0].patients.last_name
                }
                (${moment().diff(
                  data.visits[0].patients.birth_date,
                  "years"
                )} tahun)`,
                data.visits[0].patients.sexs.name,
                data.visits[0].patients.birth_date,
                this.createBUtton(data, i),
              ]}
              data={this.state.filteredDatas}
              url={"registration/prescribe/search/v2"}
              bodyRequest={this.props.keyword}
              callback={this.changeData}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default usePuskesmas(pelayananList);
